import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Input, Row, Space, Checkbox, Typography } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Datepicker } from "@ijavad805/react-datepicker";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import ModalMachine from "../../../components/Modal/Machine/ModalMachine";
import ModalLocations from "../../../components/Modal/Locations/LocationModal";
import ModalMachineType from "../../../components/Modal/MachineType/MachineType";
import ModalEquipment from "../../../components/Modal/Equipment/EquipmentModal";
import ModalOperator from "../../../components/Modal/Operator/OperatorModal";
import ModalDrivers from "../../../components/Modal/Driver/DriverModal";

const { Title } = Typography;

export default function ReportFunctionRegistrationBody() {
  const [form] = Form.useForm();
  const [machineData, setMachineData] = useState("");
  const [locationData, setLocationData] = useState("");
  const [machineTypeData, setMachineTypeData] = useState("");
  const [equipmentData, setEquipmentData] = useState("");
  const [operatorData, setOperatorData] = useState("");
  const [driverData, setDriverData] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [checkboxState, setCheckboxState] = useState({
    location: false,
    machineType: false,
    machine: false,
    driver: false,
    equipment: false,
    operator: false,
  });
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showModalLocations, setShowModalLocations] = useState(false);
  const [showModalMachineType, setShowModalMachineType] = useState(false);
  const [showModalEquipment, setShowModalEquipment] = useState(false);
  const [showModalOperator, setShowModalOperator] = useState(false);
  const [showModalDriver, setShowModalDriver] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedLocationIds, setSelectedLocationIds] = useState([]);
  const [selectedMachineTypeIds, setSelectedMachineTypeIds] = useState([]);
  const [selectedEquipmentIds, setSelectedEquipmentIds] = useState([]);
  const [selectedOperatorIds, setSelectedOperatorIds] = useState([]);
  const [selectedPersonIds, setSelectedPersonIds] = useState([]);

  const handleCheckboxChanges = (e) => {
    const { name, checked } = e.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleSubmitClick = () => {
    const payload = {
      selectedLocationIds: checkboxState.location ? selectedLocationIds : [],
      selectedMachineTypeIds: checkboxState.machineType ? selectedMachineTypeIds : [],
      selectedIds: checkboxState.machine ? selectedIds : [],
      selectedEquipmentIds: checkboxState.equipment ? selectedEquipmentIds : [],
      selectedOperatorIds: checkboxState.operator ? selectedOperatorIds : [],
      selectedPersonIds: checkboxState.driver ? selectedPersonIds : [],
      startDate: dateFrom || null,
      endDate: dateTo || null,
    };
    localStorage.setItem("reportPayloadFunctionRegistration", JSON.stringify(payload));
    navigate("/reports-function-registration/lists");
  };

  return (
    <DashboardLayout>
      <div className="p-4 bg-gray-50 min-h-screen">
        <Form form={form} layout="vertical" onFinish={handleSubmitClick}>
          <Card 
            title={
              <div className="flex items-center gap-2">
                <FilterOutlined style={{ color: "#fff" }} />
                <Title level={4} className="mb-0" style={{ color: "#fff", margin: 0 }}>فیلتر گزارش کارکرد</Title>
              </div>
            }
            className="shadow-lg mb-6"
            headStyle={{ background: "linear-gradient(180deg, #001529 0%, #002140 100%)", border: "none", color: "#fff" }}
            bodyStyle={{ padding: "24px" }}
          >
            {/* Filters Section */}
            <Card 
              title="فیلترها" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Row gutter={[16, 16]}>
                {[
                  { label: "محل استقرار", name: "location", modalSetter: setShowModalLocations, dataSetter: setLocationData, selectedIdsSetter: setSelectedLocationIds, modalState: showModalLocations, modalComponent: ModalLocations },
                  { label: "نوع دستگاه", name: "machineType", modalSetter: setShowModalMachineType, dataSetter: setMachineTypeData, selectedIdsSetter: setSelectedMachineTypeIds, modalState: showModalMachineType, modalComponent: ModalMachineType },
                  { label: "دستگاه", name: "machine", modalSetter: setShowModal, dataSetter: setMachineData, selectedIdsSetter: setSelectedIds, modalState: showModal, modalComponent: ModalMachine },
                  { label: "راننده", name: "driver", modalSetter: setShowModalDriver, dataSetter: setDriverData, selectedIdsSetter: setSelectedPersonIds, modalState: showModalDriver, modalComponent: ModalDrivers },
                  { label: "تجهیز بارگیری", name: "equipment", modalSetter: setShowModalEquipment, dataSetter: setEquipmentData, selectedIdsSetter: setSelectedEquipmentIds, modalState: showModalEquipment, modalComponent: ModalEquipment },
                  { label: "اپراتور", name: "operator", modalSetter: setShowModalOperator, dataSetter: setOperatorData, selectedIdsSetter: setSelectedOperatorIds, modalState: showModalOperator, modalComponent: ModalOperator },
                ].map((item, index) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={item.name}>
                    <Space direction="vertical" className="w-full">
                      <Checkbox
                        name={item.name}
                        checked={checkboxState[item.name]}
                        onChange={handleCheckboxChanges}
                        className="font-medium"
                      >
                        {item.label}
                      </Checkbox>
                      <Input
                        readOnly
                        onClick={(e) => {
                          e.stopPropagation();
                          item.modalSetter(true);
                        }}
                        placeholder={`انتخاب ${item.label}`}
                        value={
                          item.name === "machine" ? machineData :
                          item.name === "location" ? locationData :
                          item.name === "machineType" ? machineTypeData :
                          item.name === "equipment" ? equipmentData :
                          item.name === "operator" ? operatorData :
                          item.name === "driver" ? driverData : ""
                        }
                        addonAfter={
                          <SearchOutlined 
                            onClick={(e) => {
                              e.stopPropagation();
                              item.modalSetter(true);
                            }} 
                            className="cursor-pointer text-blue-600 hover:text-blue-800"
                          />
                        }
                        className="cursor-pointer"
                      />
                    </Space>
                  </Col>
                ))}
              </Row>
            </Card>

            {/* Date Range Section */}
            <Card 
              title="بازه تاریخی" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item label="از تاریخ">
                    <Datepicker
                      input={
                        <input
                          type="date"
                          placeholder="از تاریخ"
                          className="form-control text-sm flex-1 border-2 rounded-xl p-3 pr-12 w-full"
                        />
                      }
                      adjustPosition={"modal"}
                      onChange={(val) => {
                        setDateFrom(val.format());
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label="تا تاریخ">
                    <Datepicker
                      input={
                        <input
                          type="date"
                          placeholder="تا تاریخ"
                          className="form-control text-sm flex-1 border-2 rounded-xl p-3 pr-12 w-full"
                        />
                      }
                      adjustPosition={"modal"}
                      onChange={(val) => {
                        setDateTo(val.format());
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Submit Button */}
            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                size="large"
                className="w-full h-12 text-lg font-semibold shadow-md hover:shadow-lg transition-all"
                style={{
                  background: "linear-gradient(180deg, #001529 0%, #002140 100%)",
                  border: "none",
                }}
              >
                نمایش گزارش
              </Button>
            </Form.Item>
          </Card>
        </Form>

        {/* Modals for selecting data */}
        <ModalMachine 
          showModal={showModal} 
          setShowModal={setShowModal} 
          setData={machineData || ""} 
          onSelectedIdsChange={(data) => {
            if (data && typeof data === "object" && data.title) {
              setMachineData(data.title);
              setSelectedIds([data.id]);
            } else if (Array.isArray(data)) {
              setSelectedIds(data);
            }
          }} 
        />
        <ModalLocations 
          showModal={showModalLocations} 
          setShowModal={setShowModalLocations} 
          setData={locationData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedLocationIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalMachineType 
          showModal={showModalMachineType} 
          setShowModal={setShowModalMachineType} 
          setData={machineTypeData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedMachineTypeIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalEquipment 
          showModal={showModalEquipment} 
          setShowModal={setShowModalEquipment} 
          setData={equipmentData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedEquipmentIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalOperator 
          showModal={showModalOperator} 
          setShowModal={setShowModalOperator} 
          setData={operatorData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedOperatorIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalDrivers 
          showModal={showModalDriver} 
          setShowModal={setShowModalDriver} 
          setData={driverData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedPersonIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
      </div>
    </DashboardLayout>
  );
}
